export const environment = {
    production: true,
    googleAnalyticsTrackingID: "G-Q3CSHV649C",
    mailTokenId: "eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJBZG1pbiIsInVzZXJEZXNjcmlwdGlvbiI6IkFkbWluIiwicm9sZXMiOltdLCJpc0VuYWJsZWQiOnRydWUsImV4cCI6MTczMDQ3MjEwNCwidXNlcklkIjoxLCJpYXQiOjE2OTg5MzYxMDR9.ARn3HPLY8JcO5bqbtgZosTx207F_xv6Wc9U1nEyeUbc",
    company: "about-different",
    contactTemplate: "aboutDifferentContact",
    cookieBotDomainGroupId: "DEPRECATED",
    usercentricsId: "ZxvrKXZLn42Np6",
    companyEmail: "info@dodifferent.it"
}